'use client';

import type { NextPage } from 'next';
import { useRouter } from 'next/navigation';
import { useMemo } from 'react';
import { HeaderNavMenu, WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { useAuthState } from 'contexts/AuthProvider';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { BackButton, HomeButton } from 'ui-components/navigations/HeaderButtons';
import { useClient } from 'ui-hooks/useClient';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';
import { SettingFavoriteCategoryForm } from 'app-components/accounts/profiles/setting/favorite-category/ProfileFavoriteCategoryForm';

export const FavoriteCategoryPage: NextPage = () => {
  const router = useRouter();
  const { partner } = useAuthState();
  const client = useClient();

  useInAppHeader({
    screen: WebViewScreen.SettingFavoriteCategory,
    title: '선호 장르 설정',
    leftMenuList: [HeaderNavMenu.Back, HeaderNavMenu.Home],
  });
  useInAppStatusBar(WebViewScreen.SettingFavoriteCategory);

  const leftButtons = useMemo(() => [<BackButton key="back" />, <HomeButton key="home" />], []);

  if (partner) {
    router.replace('/');
  }

  return (
    <MutableHeaderLayout leftButtons={leftButtons} title="선호 장르 설정" isApp={client.isApp} noBottomPadding>
      <SettingFavoriteCategoryForm />
    </MutableHeaderLayout>
  );
};
